const tourCategories = [
  {
    id: "01",
    title: "Hiking and Trekking",
    links: "hikingandtrekking",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/Two-tourists-admiring-the-Rock-Lion-in-the-distance-1200x853.jpg?alt=media&token=f5625c3f-2f0d-478b-8f97-4eede291381d",
  },
  {
    id: "02",
    title: "Sun and Beach",
    links: "sunandbeach",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/IMG_5182.jpg?alt=media&token=6de78dba-b511-445f-949a-051bcd6373fe",
  },
  {
    id: "03",
    title: "Wild Safaries",
    links: "wildsafari",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/Wildlife-Safari-Sri-Lanka.jpg?alt=media&token=d2732659-a0c6-4697-b22e-bc1864d6054a",
  },
  {
    id: "04",
    title: "Cultural",
    links: "cultural",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/image_1456407546-a1f79585f6.jpg?alt=media&token=9f2b4761-f9e5-447f-9145-7d59eeae8232",
  },
  {
    id: "05",
    title: "Special",
    links: "special",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/best-ella-sri-lanka-hotels.webp?alt=media&token=9942eae7-0d5f-41e2-b7df-2ed1878bec70",
  },
  {
    id: "06",
    title: "Festival",
    links: "festival",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/travely-7264c.appspot.com/o/kataragama-temple.jpg?alt=media&token=5f477c1a-fb1a-4420-8188-1d5bf1e04457",
  },
];

export default tourCategories;
